import { Typography } from "@mui/material";
import { useOtherAppName } from "@shared/hooks/useAppName";
import { useOtherDomainGroupUrl } from "@shared/hooks/useOtherDomainGroupUrl";

type Props = {
  actionLabel: string;
  path: string;
};

export const BrandSwitchPrompt = ({ actionLabel, path }: Props) => {
  const otherAppName = useOtherAppName();
  const url = useOtherDomainGroupUrl(path);

  return (
    <Typography textAlign="center" mt={0.5}>
      Looking for {otherAppName} instead? <a href={url}>{actionLabel}</a>
    </Typography>
  );
};
